import * as API from "../../services/httpService"
import { navigate } from "gatsby"
import { parse } from "date-fns"
import {
  pageIncrement,
  controlLoading,
  controlDeclaration,
  updateUiData,
} from "../../redux/actions"
import * as CommonFunction from "../../common/function"
import * as Constants from "../../common/constants"

const SubmitClaim = (dispatch, uiData, claimData) => {
  const { chosenedBenefits } = uiData

  let submitData = Object.assign({}, claimData)
  let medicalListModel = []
  let lossListModel = []
  let otherListModel = []

  chosenedBenefits.forEach((ChosenedItem, ChosenedKey) => {
    const coverageId = ChosenedItem.CoverageDetailId
    const category = ChosenedItem.Category
    const coverageCode = ChosenedItem.CoverageCode

    // Filter empty value
    let tempBenefitData = Object.keys(claimData[category][coverageCode]).reduce(
      (object, key) => {
        if (claimData[category][coverageCode][key]) {
          object[key] = claimData[category][coverageCode][key]
        }
        return object
      },
      {}
    )

    if (submitData.claimPADetail.planPeriodFrom) {
      submitData.claimPADetail.planPeriodFrom = parse(
        submitData.claimPADetail.planPeriodFrom,
        `d${Constants.sep}M${Constants.sep}yyyy`,
        new Date()
      )
    }

    if (submitData.claimPADetail.planPeriodTo) {
      submitData.claimPADetail.planPeriodTo = parse(
        submitData.claimPADetail.planPeriodTo,
        `d${Constants.sep}M${Constants.sep}yyyy`,
        new Date()
      )
    }

    //calculate total claim amount
    if (tempBenefitData.claimAmount) {
      submitData.claimPADetail.claimAmount =
        submitData.claimPADetail.claimAmount + tempBenefitData.claimAmount
    }

    switch (category) {
      case "Medical":
        tempBenefitData.coverageId = coverageId
        tempBenefitData.coverageCode = coverageCode

        switch (coverageCode) {
          case "AD":
          case "CAD":
            // tempBenefitData.deathNature =
            //   tempBenefitData.deathNatureType +
            //   ", " +
            //   tempBenefitData.deathNature

            tempBenefitData.occurrenceDate = CommonFunction.combineDateAndTime(
              tempBenefitData.occurrenceDate,
              tempBenefitData.occurrenceTime
            )

            tempBenefitData.deathDate = CommonFunction.combineDateAndTime(
              tempBenefitData.deathDate,
              tempBenefitData.deathTime
            )

            if (tempBenefitData.victimBirthDate) {
              tempBenefitData.victimBirthDate = parse(
                tempBenefitData.victimBirthDate,
                `d${Constants.sep}M${Constants.sep}yyyy`,
                new Date()
              )
              tempBenefitData.victimBirthDate = CommonFunction.combineDateAndTime(
                tempBenefitData.victimBirthDate,
                "00:00"
              )
            }
            break

          case "AP":
          case "AT":
          case "PD":
            tempBenefitData.occurrenceDate = CommonFunction.combineDateAndTime(
              tempBenefitData.occurrenceDate,
              tempBenefitData.occurrenceTime
            )

            //concatenate disablement list
            let disablementDescription = ""

            if (tempBenefitData.disablementDescription.length === 1) {
              disablementDescription =
                tempBenefitData.disablementDescription[0].label
            } else {
              disablementDescription = tempBenefitData.disablementDescription.reduce(
                (previous, current) => {
                  return (
                    (previous.label ? previous.label : previous) +
                    ", " +
                    current.label
                  )
                }
              )
            }

            if (tempBenefitData.victimBirthDate) {
              tempBenefitData.victimBirthDate = parse(
                tempBenefitData.victimBirthDate,
                `d${Constants.sep}M${Constants.sep}yyyy`,
                new Date()
              )
              tempBenefitData.victimBirthDate = CommonFunction.combineDateAndTime(
                tempBenefitData.victimBirthDate,
                "00:00"
              )
            }

            tempBenefitData.disablementDescription = disablementDescription

            break
          case "AM":
          case "AMBI":
          case "AMID":
          case "AMFR":
          case "AMCM":
          case "AMIM":
          case "AMDT":
          case "AMSG":
          case "ME":
          case "AMCIM":
            tempBenefitData.occurrenceDate = CommonFunction.combineDateAndTime(
              tempBenefitData.occurrenceDate,
              tempBenefitData.occurrenceTime
            )

            //append medical list
            tempBenefitData.PAMedicalDetailListModel = []
            for (var medicalDetail of tempBenefitData.MedicalDetailList) {
              tempBenefitData.PAMedicalDetailListModel.push({
                medicalType: medicalDetail.medicalType,
                receiptDate: medicalDetail.receiptDate,
                claimAmount: medicalDetail.claimAmount,
              })
            }

            break
          case "HA":
            tempBenefitData.occurrenceDate = CommonFunction.combineDateAndTime(
              tempBenefitData.occurrenceDate,
              "00:00"
            )
            tempBenefitData.admissionDate = CommonFunction.combineDateAndTime(
              tempBenefitData.admissionDate,
              tempBenefitData.admissionTime
            )
            tempBenefitData.dischargeDate = CommonFunction.combineDateAndTime(
              tempBenefitData.dischargeDate,
              tempBenefitData.dischargeTime
            )
            break
          default:
            break
        }
        //console.log(tempBenefitData)

        medicalListModel.push(tempBenefitData)
        break
      case "Loss":
        tempBenefitData.coverageId = coverageId
        tempBenefitData.coverageCode = coverageCode

        switch (coverageCode) {
          case "BL":
          case "BAD":
          case "BMD":
          case "BTH":
            tempBenefitData.occurrenceDate = CommonFunction.combineDateAndTime(
              tempBenefitData.occurrenceDate,
              tempBenefitData.occurrenceTime
            )

            //concatenate damage part
            let damagePart = ""

            if (tempBenefitData.damagePart !== undefined) {
              if (tempBenefitData.damagePart.length === 1) {
                damagePart = tempBenefitData.damagePart[0].label
              } else {
                damagePart = tempBenefitData.damagePart.reduce(
                  (previous, current) => {
                    return (
                      (previous.label ? previous.label : previous) +
                      ", " +
                      current.label
                    )
                  }
                )
              }
            }

            tempBenefitData.damagePart = damagePart

            break
          default:
            break
        }
        //console.log(tempBenefitData)

        lossListModel.push(tempBenefitData)
        break
      case "Other":
        tempBenefitData.coverageId = coverageId
        tempBenefitData.coverageCode = coverageCode

        switch (coverageCode) {
          case "OB":
            tempBenefitData.occurrenceDate = CommonFunction.combineDateAndTime(
              tempBenefitData.occurrenceDate,
              tempBenefitData.occurrenceTime
            )

            //append other benefits list
            tempBenefitData.PAOtherItemListModel = []
            for (var otherItem of tempBenefitData.OtherItemList) {
              tempBenefitData.PAOtherItemListModel.push({
                benefitClaimed: otherItem.benefitClaimed,
                claimAmount: otherItem.claimAmount,
              })
            }
            break
          default:
            break
        }

        //console.log(tempBenefitData)

        otherListModel.push(tempBenefitData)
        break
      default:
        break
    }
  })

  if (isNaN(submitData.claimPADetail.claimAmount)) {
    submitData.claimPADetail.claimAmount = 0
  }

  // Assign declaration check box value
  submitData.claimPADetail.declaration = uiData.checkBoxStatus.isAgree

  // console.log(
  //   JSON.stringify({
  //     claimHeaderModel: submitData.claimPADetail,
  //     claimPADetailModel: submitData.claimPADetail,

  //     PAMedicalListModel: medicalListModel,
  //     PALossListModel: lossListModel,
  //     PAOtherListModel: otherListModel,

  //     claimUploadListModel: uiData.claimUploadListModel,
  //     claimAttributeModel: submitData.claimAttributeModel,
  //     folderName: uiData.folderName,
  //   })
  // )

  API.apiPostRequest(
    "/Claim/PASubmitClaim",
    {
      claimHeaderModel: submitData.claimPADetail,
      claimPADetailModel: submitData.claimPADetail,

      PAMedicalListModel: medicalListModel,
      PALossListModel: lossListModel,
      PAOtherListModel: otherListModel,

      claimUploadListModel: uiData.claimUploadListModel,
      claimAttributeModel: submitData.claimAttributeModel,
      folderName: uiData.folderName,
      // sessionId: "",
    },
    null
  ).then(
    submitClaimResponse => {
      // console.log(submitClaimResponse)
      dispatch(controlDeclaration())
      dispatch(pageIncrement())
      dispatch(
        updateUiData(
          "submittedClaimID",
          submitClaimResponse.data.ClaimRequestNumber
        )
      )

      dispatch(controlLoading())
    },
    error => {
      navigate("errorOccurred")
    }
  )
}

export default SubmitClaim
